import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PGSurveyAnswers, PGSurveyAnswersQuestion } from '../../../models/booking.model';
import { SurveyData } from '../../../models/survey.model';
import { LocalizationService } from '../../../services/localization.service';

@Component({
    selector: 'app-pg-survey-answers',
    templateUrl: './pg-survey-answers.component.html',
    styleUrls: ['./pg-survey-answers.component.scss'],
    standalone: false
})
export class PgSurveyAnswersComponent implements OnInit {

    answers:PGSurveyAnswers = null;

    randomId = Math.random()

    @Input() surveyData:SurveyData;
    @Output() surveyAnswered = new EventEmitter<PGSurveyAnswers>();

    constructor(private localizationService:LocalizationService) { }

    ngOnInit(): void {
        this.answers = new PGSurveyAnswers(this.surveyData);
    }

    formatQuestionText(text:string|{ [lang:string]: string }) {
        return this.localizationService.getTranslatedValue(text);
    }

    isQuestionUnanswered(question:PGSurveyAnswersQuestion) {
        if(question.type == 'boolean') return question.answer == null;
        else if(question.type == 'string') return question.answer == null || question.answer == '';
    }

    isSubmitDisabled() {
        for(let _question of this.answers.questions) {
            if(_question.required && this.isQuestionUnanswered(_question)) return true
        }
    }
}
